/**
 * Default Lead Sources for Service Businesses
 * 
 * These are common lead sources that most service businesses use.
 * Each new organization gets their own copy of these defaults that they can customize.
 */

export const DEFAULT_LEAD_SOURCES = [
  {
    name: "Google Search",
    description: "Organic search results from Google",
    category: "search"
  },
  {
    name: "Google Ads",
    description: "Paid advertising on Google",
    category: "paid"
  },
  {
    name: "Facebook Ads",
    description: "Paid advertising on Facebook/Meta",
    category: "paid"
  },
  {
    name: "Instagram Ads",
    description: "Paid advertising on Instagram",
    category: "paid"
  },
  {
    name: "Referral",
    description: "Customer referrals and word-of-mouth",
    category: "referral"
  },
  {
    name: "Website Contact Form",
    description: "Direct inquiries through website",
    category: "direct"
  },
  {
    name: "Phone Call",
    description: "Direct phone inquiries",
    category: "direct"
  },
  {
    name: "Walk-in",
    description: "Customers who visit location directly",
    category: "direct"
  },
  {
    name: "Yelp",
    description: "Leads from Yelp business listing",
    category: "directory"
  },
  {
    name: "Google My Business",
    description: "Leads from Google Business Profile",
    category: "directory"
  },
  {
    name: "Angie's List",
    description: "Leads from Angie's List directory",
    category: "directory"
  },
  {
    name: "HomeAdvisor",
    description: "Leads from HomeAdvisor platform",
    category: "directory"
  },
  {
    name: "Thumbtack",
    description: "Leads from Thumbtack marketplace",
    category: "directory"
  },
  {
    name: "Email Marketing",
    description: "Email campaigns and newsletters",
    category: "marketing"
  },
  {
    name: "Direct Mail",
    description: "Physical mail campaigns",
    category: "marketing"
  },
  {
    name: "Yellow Pages",
    description: "Traditional Yellow Pages directory",
    category: "directory"
  },
  {
    name: "Nextdoor",
    description: "Neighborhood social network",
    category: "social"
  },
  {
    name: "LinkedIn",
    description: "Professional networking platform",
    category: "social"
  },
  {
    name: "Trade Show",
    description: "Industry trade shows and events",
    category: "events"
  },
  {
    name: "Radio Ad",
    description: "Radio advertising campaigns",
    category: "traditional"
  },
  {
    name: "TV Ad",
    description: "Television advertising campaigns",
    category: "traditional"
  },
  {
    name: "Newspaper Ad",
    description: "Print newspaper advertising",
    category: "traditional"
  },
  {
    name: "Vehicle Wrap",
    description: "Leads from vehicle advertising",
    category: "outdoor"
  },
  {
    name: "Yard Sign",
    description: "Leads from yard signs and signage",
    category: "outdoor"
  },
  {
    name: "Billboard",
    description: "Outdoor billboard advertising",
    category: "outdoor"
  }
];

/**
 * Get default lead sources by category
 */
export const getDefaultLeadSourcesByCategory = () => {
  const categories = {};
  
  DEFAULT_LEAD_SOURCES.forEach(source => {
    if (!categories[source.category]) {
      categories[source.category] = [];
    }
    categories[source.category].push(source);
  });
  
  return categories;
};

/**
 * Get most common lead sources (top 10)
 */
export const getMostCommonLeadSources = () => {
  return DEFAULT_LEAD_SOURCES.slice(0, 10);
};

/**
 * Check if a lead source name matches a default
 */
export const isDefaultLeadSource = (name) => {
  return DEFAULT_LEAD_SOURCES.some(source => 
    source.name.toLowerCase() === name.toLowerCase()
  );
};

/**
 * Get default lead source by name
 */
export const getDefaultLeadSource = (name) => {
  return DEFAULT_LEAD_SOURCES.find(source => 
    source.name.toLowerCase() === name.toLowerCase()
  );
}; 